// @core/api/endpoints/notifications/update_channel_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateChannelConfigRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update channel configuration
 * Updates the provider-specific configuration for a notification channel. Supports email, SMS, push, and webhook configurations.
 */
export async function UpdateChannelConfig(
  channel_id: string,
  data: UpdateChannelConfigRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id/config`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
